import * as React from 'react';
import { Alert, Avatar, Box, Button, ButtonProps, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Fade, FormControl, FormControlLabel, Grid, IconButton, InputLabel, LinearProgress, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Select, SelectChangeEvent, Switch, Tooltip, Typography } from '@mui/material';
import $ from "jquery";
import UserNew from './UserNew';
import { DataGrid, GridRowSelectionModel, GridRowId, GridCallbackDetails, GridPaginationModel, GridCsvExportOptions, GridCsvGetRowsToExportParams, GridToolbarContainer, gridExpandedSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
import UserDelete from './UserDelete';
import UserEdit from './UserEdit';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Common from '../../utilities/common';
import Layout from '../../components/Utilities/Layout';
import { User } from './User';
import EntitySettings from '../../components/EntitySettings';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import { Entity, Permiso, PermissionLevel } from '../../utilities/Permisos';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import PasswordOutlinedIcon from '@mui/icons-material/PasswordOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import { Apellido } from '../../Apellidos/Apellido';
import FeatureManager from '../../components/Utilities/FeatureManager';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const CustomToolbar = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'usuarios' })}
        >
          Exportar CSV
        </Button>
      </GridToolbarContainer>
    );
}

export interface IUserState {
    data: User[];
    permissionLevels: any[];
    entidades: any[];
    loading: boolean;
    openNewForm: boolean;
    openEditForm: boolean;
    openDeleteForm: boolean;
    openImportProgress: boolean;
    selectedUser: GridRowId[];
    progress: number;
    progressMessage: string;
    checkBoxSelection: boolean;
    errors: string[];
    currentPage: number;
    iconButtonPressed: null | HTMLElement;
    openRowMenu: boolean;
    selectedRow: any;
    openDefaultPermissionsDialog: boolean;
    showProgress: boolean;
}

export default class UserView extends React.Component<{}, IUserState> {
    _file: any;
    _fileContent: any[] = [];
    _errors: string[] = [];
    _permiso: number = -1;

    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            permissionLevels: [],
            entidades: [],
            loading: true,
            openNewForm: false,
            openEditForm: false,
            openDeleteForm: false,
            openImportProgress: false,
            selectedUser: [],
            checkBoxSelection: false,
            progress: 0,
            progressMessage: '',
            errors: [],
            currentPage: 0,
            iconButtonPressed: null,
            openRowMenu: false,
            selectedRow: null,
            openDefaultPermissionsDialog: false,
            showProgress: false
        };
    }

    componentDidMount(): void {
        this.Get();
        this.GetPermissionLevels();
        this.GetEntidades();
    }

    public render(): React.ReactElement<{}> {
        return (
            <FeatureManager entidad={Entity.Usuarios} operacion='Ver' showBuyOption>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Configuración',
                            url: '/settings'
                        },
                        {
                            title: 'Usuarios',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <PeopleAltOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Usuarios
                                </Typography>
                            </Grid>
                            <SecurityTrimmer entity={Entity.Usuarios} permission={PermissionLevel.Ver}>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntitySettings entity={Entity.Usuarios}/>
                                </Grid>
                            </SecurityTrimmer>
                        </Grid>
                    </Box>
                    <Box className='main'>
                        <Grid container style={{borderBottom: 'solid 1px #666', marginBottom: '40px'}}>
                            <Grid item xs={4}>
                                <Typography variant='h6'>Datos</Typography>
                            </Grid>
                            <Grid item xs={8} style={{textAlign: 'right'}}>
                                <FormControlLabel control={<Switch defaultChecked={false} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    this.setState(
                                        {
                                            checkBoxSelection: event.target.checked
                                        }
                                    );
                                }}/>} label="Selección múltiple" />
                            </Grid>
                        </Grid>
                        {
                            this.state.loading && (
                                <div style={{textAlign: 'center', marginTop: '40px'}}>
                                    <CircularProgress />
                                </div>
                            )
                        }
                        {
                            !this.state.loading && this.state.data.length == 0 && (
                                <Alert style={{marginTop: '40px'}} severity="warning">No se han encontrado resultados.</Alert>
                            )
                        }
                        {
                            !this.state.loading && this.state.data.length > 0 && (
                                <DataGrid
                                    autoHeight
                                    slots={{ toolbar: CustomToolbar }}
                                    slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                    rows={this.state.data}
                                    columns={[
                                        { 
                                            field: 'id', 
                                            headerName: '', 
                                            width: 50,
                                            renderCell: ({ row }) => (
                                                this.RenderRowMenu(row)
                                            )
                                        },
                                        { field: 'avatar', headerName: '', width: 50, renderCell: ({ row }) => (this.RenderAvatar(row)) },
                                        { field: 'nombre', headerName: 'Nombre', width: 200 },
                                        { field: 'apellidos', headerName: 'Apellidos', width: 200 },
                                        { field: 'userName', headerName: 'Email', width: 500 },
                                        { field: 'activo', headerName: '', flex: 1, renderCell: ({ row }) => (
                                            <React.Fragment>
                                                {
                                                    this.state.showProgress && this.state.selectedRow['id'] == row['id'] && (
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <Box sx={{ width: '100%', mr: 1 }}>
                                                                <LinearProgress variant="determinate" value={this.state.progress} />
                                                            </Box>
                                                            <Box sx={{ minWidth: 35 }}>
                                                                <Typography variant="body2" color="text.secondary">
                                                                    {
                                                                        `${this.state.progress}%`
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    )
                                                }
                                            </React.Fragment>
                                        ) }
                                    ]}
                                    initialState={{
                                        pagination: {
                                            paginationModel: { page: this.state.currentPage, pageSize: 30 },
                                        },
                                    }}
                                    pageSizeOptions={[30, 60, 100]}
                                    checkboxSelection={this.state.checkBoxSelection}
                                    onRowSelectionModelChange={(row: GridRowSelectionModel) => {
                                        this.setState({
                                            selectedUser: row,
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openDeleteForm: false,
                                            openEditForm: false
                                        });
                                    }}
                                    onPaginationModelChange={(model: GridPaginationModel, details: GridCallbackDetails) => {
                                        this.setState({
                                            currentPage: model.page
                                        });
                                    }}
                                    hideFooter={this.state.data.length <= 30}
                                />
                            )
                        }
                    </Box>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={12} style={{textAlign: 'right'}}>
                                <FeatureManager entidad={Entity.Usuarios} operacion='Crear'>
                                    <Button variant="contained" onClick={() => {
                                        this.setState(
                                            {
                                                openNewForm: true,
                                                openImportProgress: false,
                                                openEditForm: false,
                                                openDeleteForm: false
                                            }
                                        );
                                    }}>
                                        Nuevo
                                    </Button>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.Usuarios} operacion='Editar'>
                                    <Button variant="contained" disabled={this.state.selectedUser.length != 1} onClick={() => {
                                        this.setState(
                                            {
                                                openNewForm: false,
                                                openImportProgress: false,
                                                openEditForm: true,
                                                openDeleteForm: false
                                            }
                                        );
                                    }}>
                                        Modificar
                                    </Button>
                                </FeatureManager>
                                <FeatureManager entidad={Entity.Usuarios} operacion='Eliminar'>
                                    <Button variant="contained" disabled={this.state.selectedUser.length == 0} onClick={() => {
                                        this.setState(
                                            {
                                                openNewForm: false,
                                                openImportProgress: false,
                                                openEditForm: false,
                                                openDeleteForm: true
                                            }
                                        );
                                    }}>
                                        Eliminar
                                    </Button>
                                </FeatureManager>
                            </Grid>
                        </Grid>
                    </Box>
                    <UserNew open={this.state.openNewForm} onSave={this.Get.bind(this)} />
                    <UserDelete open={this.state.openDeleteForm} id={this.state.selectedUser as number[]} onDelete={this.Get.bind(this)} />
                    <UserEdit open={this.state.openEditForm} onSave={this.Get.bind(this)} selectedItem={this.GetselectedUser()}/>
                    <Dialog open={this.state.errors.length > 0} fullWidth>
                        <DialogTitle>
                            Error
                        </DialogTitle>
                        <DialogContent>
                            <Typography variant='body2'>
                                Se han producido los siguientes errores durante la importación:
                            </Typography>
                            <div className='errors'>
                                <List>
                                    {
                                        this.state.errors.map((value: string, index: number) => {
                                            return (
                                                <ListItem disablePadding>
                                                    <ListItemButton>
                                                        <ListItemIcon>
                                                            <CancelOutlinedIcon />
                                                        </ListItemIcon>
                                                        <ListItemText primary={value} />
                                                    </ListItemButton>
                                                </ListItem>
                                            )
                                        })
                                    }
                                </List>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => {
                                this.setState(
                                    {
                                        errors: []
                                    }
                                );
                            }}>Ok</Button>
                        </DialogActions>
                    </Dialog>
                    <Menu
                        anchorEl={this.state.iconButtonPressed}
                        open={this.state.openRowMenu}
                        onClose={() => {
                            this.setState(
                                {
                                    iconButtonPressed: null,
                                    openRowMenu: false
                                }
                            );
                        }}
                    >
                        <MenuItem onClick={() => {
                            this.ResetPassword();
                        }}>
                            <ListItemIcon>
                                <PasswordOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Reestablecer contraseña</ListItemText>
                        </MenuItem>
                        <MenuItem onClick={() => {
                            this.setState(
                                {
                                    openDefaultPermissionsDialog: true,
                                    showProgress: false,
                                    progress: 0,
                                    openRowMenu: false
                                }
                            )
                        }}>
                            <ListItemIcon>
                                <SecurityOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Establecer nivel de permisos por defecto</ListItemText>
                        </MenuItem>
                    </Menu>
                    <Dialog open={this.state.openDefaultPermissionsDialog} fullWidth>
                        <DialogTitle>
                            Establecer nivel de permisos por defecto
                        </DialogTitle>
                        <DialogContent>
                            <FormControl required fullWidth variant="standard">
                                <InputLabel id="labelPermisos">Seleccione un nivel de permisos</InputLabel>
                                <Select label="Seleccione un nivel de permisos" labelId='labelPermisos' onChange={(event: SelectChangeEvent) => {
                                    this._permiso = Number(event.target.value);
                                }}>
                                    {
                                        this.state.permissionLevels.map((value: any, index: number) => {
                                            return (
                                                <MenuItem value={value.id}>
                                                    {
                                                        value.nombre
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => {
                                this.SetPermission(0);
                            }}>OK</Button>
                            <Button onClick={() => {
                                this.setState(
                                    {
                                        openDefaultPermissionsDialog: false
                                    }
                                )
                            }}>Cancelar</Button>
                        </DialogActions>
                    </Dialog>
                </Layout>
            </FeatureManager>
        )
    }

    private GetselectedUser(): User | undefined {
        return this.state.data.find((value: User) => {
            return value.id == this.state.selectedUser[0] as number;
        });
    }

    private Get(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/masters/users`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response,
                    openNewForm: false,
                    openImportProgress: false,
                    openDeleteForm: false,
                    openEditForm: false,
                    selectedUser: [],
                    loading: false,
                    progress: 0
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }

    private GetPermissionLevels(): void {
        let url = `${Common.END_POINT}/permissions/levels`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    permissionLevels: response
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }

    private GetEntidades(): void {
        let url = `${Common.END_POINT}/entidades`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    entidades: response
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }

    private SetPermission(index: number) {
        if(index >= this.state.entidades.length) {
            this.setState(
                {
                    showProgress: false,
                    progress: 0
                }
            );

            return;
        }

        const permiso: Permiso = new Permiso();
        permiso.nivelPermisoId = this._permiso;
        permiso.entidadId = this.state.entidades[index].id;
        permiso.userId = this.state.selectedRow.id;

        let url = `${Common.END_POINT}/permissions`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(permiso),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            this.setState({
                showProgress: true,
                openDefaultPermissionsDialog: false,
                progress: Math.round((index / this.state.entidades.length) * 100)
            });

            let newIndex = index + 1;
            this.SetPermission(newIndex);
        }).fail((jqXHR, textStatus, errorThrown) => {

        });
    }

    private ResetPassword(): void {
        const userId = this.state.selectedRow['id'];
        let url = `${Common.END_POINT}/masters/users/${userId}/resetpass`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    iconButtonPressed: null,
                    openRowMenu: false
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }

    private RenderRowMenu(row: any): JSX.Element {
        return (
            <FeatureManager entidad={Entity.Usuarios} operacion='Editar'>
                <SecurityTrimmer entity={Entity.Datos} permission={PermissionLevel.Editar}>
                    <div className='textCenter'>
                        <IconButton onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                            this.setState(
                                {
                                    iconButtonPressed: event.currentTarget,
                                    openRowMenu: true,
                                    selectedRow: row
                                }
                            );
                        }}>
                            <MoreVertOutlinedIcon/>
                        </IconButton>
                    </div>
                </SecurityTrimmer>
            </FeatureManager>
        )
    }

    private RenderAvatar(row: any): JSX.Element {
        return (
            <Avatar src={row.avatar} sx={{ width: 32, height: 32, bgcolor: row.avatarColor, position: 'relative', top: '10px' }}>
                <Typography variant='body2' style={{position: 'relative', top: '2px'}}>
                    {
                        Common.GetNameInitials(`${row.nombre} ${row.apellidos}`)
                    }
                </Typography>
            </Avatar>
        )
    }
}